var map = {
	"./Bar/Big.svg": 82180,
	"./Bar/Huge.svg": 4639,
	"./Bar/Micro.svg": 63362,
	"./Bar/Small.svg": 17099,
	"./Check/Big.svg": 98207,
	"./Check/Huge.svg": 7090,
	"./Check/Micro.svg": 19229,
	"./Check/Small.svg": 78408,
	"./Cross/Big.svg": 33567,
	"./Cross/Huge.svg": 65938,
	"./Cross/Micro.svg": 96573,
	"./Cross/Small.svg": 9576,
	"./Node/Big.svg": 98579,
	"./Node/Huge.svg": 83230,
	"./Node/Micro.svg": 40473,
	"./Node/Small.svg": 40812,
	"./Ring/Big.svg": 84881,
	"./Ring/Huge.svg": 43060,
	"./Ring/Micro.svg": 32035,
	"./Ring/Small.svg": 16614,
	"./Spinner/Big.svg": 78524,
	"./Spinner/Huge.svg": 5863,
	"./Spinner/Micro.svg": 83162,
	"./Spinner/Small.svg": 72227,
	"./Triangle/Big.svg": 86435,
	"./Triangle/Huge.svg": 72174,
	"./Triangle/Micro.svg": 74761,
	"./Triangle/Small.svg": 27228,
	"./WeirdBurger/Big.svg": 51575,
	"./WeirdBurger/Huge.svg": 91866,
	"./WeirdBurger/Micro.svg": 74805,
	"./WeirdBurger/Small.svg": 65440
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4784;